import { useState } from "react";
import { menuNew, newsContent } from "./Datamenu_inc";
import { motion } from "framer-motion";
import Loading from "../component/Loading";
import Card from "../component/Card";

export const DataNews_1 = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6; // จํานวนรายการต่อหน้า
  const totalPages = Math.ceil(newsContent.length / itemsPerPage);
  const maxPagesToShow = 5; // จำนวนหน้าที่แสดงใน pagination

  // คำนวณ index ของรายการที่แสดงในหน้าปัจจุบัน
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = newsContent.slice(indexOfFirstItem, indexOfLastItem);

  // ฟังก์ชันเปลี่ยนหน้า
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // สร้าง array ของหน้าที่จะแสดง
  const getPageNumbers = () => {
    const pages = [];
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = startPage + maxPagesToShow - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };
  const NewsPr = menuNew[0]?.name;

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="flex flex-col  gap-10 pt-20 lg:px-0 px-10 mb-10"
      >
        <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81] ">
          {NewsPr.split("").map((char, index) => (
            <motion.span
              key={index}
              custom={index}
              variants={{
                hidden: { opacity: 0, y: 10 },
                visible: (i) => ({
                  opacity: 1,
                  y: 0,
                  transition: { delay: i * 0.1, duration: 0.3 },
                }),
              }}
              initial="hidden"
              animate="visible"
              exit="hidden"
            >
              {char}
            </motion.span>
          ))}
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="pb-20"
      >
        <Loading data={currentItems}>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-3 ">
            {currentItems.map((item) => (
              <Card key={item.id} item={item} />
            ))}
          </div>
        </Loading>
        {/* Pagination Controls */}
        <div className="flex justify-start mt-4">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="mx-1 px-3 py-1 rounded bg-gray-200 disabled:opacity-50 text-[#0F4D81]"
          >
            <i className="fa fa-arrow-left"></i>
          </button>

          {currentPage > maxPagesToShow / 2 + 1 && (
            <>
              <button
                onClick={() => paginate(1)}
                className="mx-1 px-3 py-1 rounded bg-gray-200"
              >
                1
              </button>
              <span className="mx-1 px-3 py-1">...</span>
            </>
          )}

          {getPageNumbers().map((page) => (
            <button
              key={page}
              onClick={() => paginate(page)}
              className={`mx-1 px-3 py-1 rounded ${
                currentPage === page
                  ? "bg-[#0F4D81] text-white"
                  : "bg-gray-200 text-[#0F4D81]"
              }`}
            >
              {page}
            </button>
          ))}

          {currentPage < totalPages - maxPagesToShow / 2 && (
            <>
              <span className="mx-1 px-3 py-1">...</span>
              <button
                onClick={() => paginate(totalPages)}
                className="mx-1 px-3 py-1 rounded bg-gray-200 text-[#0F4D81]"
              >
                {totalPages}
              </button>
            </>
          )}

          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="mx-1 px-3 py-1 rounded bg-gray-200 disabled:opacity-50 text-[#0F4D81]"
          >
            <i className="fa fa-arrow-right"></i>
          </button>
        </div>
      </motion.div>
    </>
  );
};
